/**
 * Centralized SEO configuration.
 * All public pages should reference this for canonical base URL, site name, and default meta.
 */
export const SEO_CONFIG = {
  /** Base URL for canonical links and OG tags (no trailing slash) */
  baseUrl: 'https://ashlarapp.com',
  /** Site name for og:site_name and JSON-LD */
  siteName: 'Ashlar App',
  /** Default OG image (absolute URL) */
  defaultOgImage: 'https://ashlarapp.com/og-image.png',
  /** Twitter handle (without @) */
  twitterHandle: 'ashlarapp',
  /** Default locale */
  locale: 'en_US',
} as const;
